import { api, getToken } from './client';

export const tenantsApi = {
  listar: () => api.get('/tenants'),
  criar: (dados) => api.post('/tenants', dados),
  atualizar: (id, dados) => api.put(`/tenants/${id}`, dados),
  excluir: (id, senha) => api.del(`/tenants/${id}`, { senha })
};

export const empresasApi = {
  listar: (tenantId) => api.get(`/empresas?tenant_id=${tenantId}`),
  criar: (dados) => api.post('/empresas', dados),
  atualizar: (id, dados) => api.put(`/empresas/${id}`, dados),
  tornarPadrao: (id) => api.post(`/empresas/${id}/tornar-padrao`),
  enviarLogo: async (id, arquivo) => {
    const formData = new FormData();
    formData.append('logo', arquivo);
    const res = await fetch(`/api/empresas/${id}/logo`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${getToken()}` },
      body: formData
    });
    const corpo = await res.json();
    if (!res.ok) throw new Error(corpo.erro || 'Erro ao enviar logo');
    return corpo;
  }
};

export const usuariosApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/usuarios${qs ? `?${qs}` : ''}`);
  },
  listarVendedores: () => api.get('/usuarios/vendedores'),
  criar: (dados) => api.post('/usuarios', dados),
  atualizar: (id, dados) => api.put(`/usuarios/${id}`, dados),
  obterEmpresas: (id) => api.get(`/usuarios/${id}/empresas`)
};

export const logAuditoriaApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/log-auditoria${qs ? `?${qs}` : ''}`);
  }
};

export const vendedoresApi = {
  listar: () => api.get('/usuarios/vendedores')
};
